export default "__VITE_ASSET__cd71ad16__"